<template>
  <footer class="site">
    <div class="wrap">
      <div>
        <div class="flogo"><LogoFull /></div>
        <p class="mission">Building dreams for the next generations, from everywhere to everywhere. USA headquarters in New Jersey, with branches in Baghdad, Amman and Beirut.</p>
      </div>
      <div><h4>Explore</h4><ul><li><router-link to="/about">About us</router-link></li><li><router-link to="/programs">Programs</router-link></li><li><router-link to="/faq">FAQ</router-link></li><li><router-link to="/policy">Nondiscriminatory policy</router-link></li></ul></div>
      <div><h4>Get involved</h4><ul><li><router-link to="/support#teach">Teach</router-link></li><li><router-link to="/support#give">Give</router-link></li><li><router-link to="/support#partner">Partner</router-link></li><li><button class="signin" type="button" style="color:#C3C6E6;padding:0;font-size:15px" @click="findStudent">Find a Student</button></li></ul></div>
      <div><h4>Contact</h4><ul><li>admin@thedreaminc.org</li><li>Donations: finance@thedreaminc.org</li><li>New Jersey, United States</li></ul></div>
      <div class="fine"><span>&copy; 2026 The Dream Inc., d/b/a The Dream International. A 501(c)(3) public charity, EIN 30-1295205.</span><span class="slogan" style="color:#F1CF63">Make it happen.</span></div>
    </div>
  </footer>
</template>

<script>
import LogoFull from './LogoFull.vue';
import { auth } from '@/firebase.config';
import { openLogin } from '@/composables/useLogin';

export default {
  name: 'SiteFooter',
  components: { LogoFull },
  methods: {
    // Signed out: the portal starts at sign-in (as in the design). Signed in:
    // MyPage is where matched contacts live; /find-students stays unlinked
    // as it was before the redesign.
    findStudent() {
      if (this.$store.getters['authStore/user'] || auth.currentUser) {
        this.$router.push({ name: 'StudentPage' });
      } else {
        openLogin();
      }
    },
  },
};
</script>
